import Conditions from './conditions';

export default Conditions;
